import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Auth Guard - Protects routes that require authentication.
 * Checks if user has a valid googleUser in localStorage.
 * Redirects to home page (login) if not authenticated.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const storedUser = localStorage.getItem('googleUser');
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      if (user && user.email) {
        return true;
      }
    } catch {
      // Invalid data in localStorage, clear it
      localStorage.removeItem('googleUser');
      localStorage.removeItem('userRole');
    }
  }

  console.log('🚫 Auth Guard: User not authenticated, redirecting to login');
  router.navigate(['/']);
  return false;
};
